export const colorCodesForAvatar = [
    "#405261", // A
    "#FF4D4F", // B
    "#FA541C", // C
    "#FA8C16", // D
    "#FAAD14", // E
    "#EB2F96", // F
    "#FADB14", // G
    "#A0D911", // H
    "#52C41A", // I
    "#5CDBD3", // J
    "#9254DE", // K
    "#F759AB", // L
    "#2F54EB", // M
    "#722ED1", // N
    "#1890FF", // O
    "#13C2C2", // P
    "#2DB7F5", // Q
    "#19BE6B", // R
    "#30A745", // S
    "#FA8C16", // T
    "#FAAD14", // U
    "#9254DE", // V
    "#F759AB", // W
    "#13C2C2", // X
    "#722ED1", // Y
    "#2DB7F5", // Z
  ];


  export const tabs = ["Total Chats", "Total Tickets", "Website Traffic", "Chat Satisfaction"]
  export const timeOptions = ["7 days", "30 days", "12 month"]
  
  // Knowledge Base Overview mocks
  export const KB_OVERVIEW_SUMMARY_MOCK = [
    { title: 'Published', number: 142, textPercentage: null, value: '' },
    { title: 'Drafts', number: 8, textPercentage: null, value: '' },
    { title: 'Pending Review', number: 42, textPercentage: null, value: '' },
    { title: 'Archived', number: 67, textPercentage: null, value: '' },
  ]

  export const KB_RECENT_ACTIVITY_MOCK = [
    { title: 'Getting Started with TrustChat', status: 'Published', isNew: false, creator: 'Sarah Chen', updated: '2 hours ago' },
    { title: 'API Authentication Guide', status: 'Pending Review', isNew: false, creator: 'Michael Rodriguez', updated: '4 hours ago' },
    { title: 'Troubleshooting Connection Issues', status: 'Published', isNew: true, creator: 'Emma Wilson', updated: '5 hours ago' },
    { title: 'Advanced Webhook Configuration', status: 'Pending Review', isNew: false, creator: 'James Park', updated: '1 day ago' },
    { title: 'Mobile App Setup Guide', status: 'Published', isNew: true, creator: 'Emma Wilson', updated: '1 day ago' },
  ]

  export const userData = [
    {
      id: 1,
      name: "Robert Fox",
      email: "jessica.hanson@example.com",
      activity: "Queued",
      time: "7min 23s",
      chatWith: "Arlene McCoy",
      action: "Pick from Queue",
      actionType: "green",
      avatar: null,
      trafficStatus: "queued",
    },
    {
      id: 2,
      name: "Devon Lane",
      email: "tanya.hill@example.com",
      activity: "Browsing",
      time: "22min 10s",
      chatWith: "-",
      action: "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 3,
      name: "Courtney Henry",
      email: "nevaeh.simmons@example.com",
      activity: "Browsing",
      time: "25 min",
      chatWith: "-",
      action: "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 4,
      name: "Theresa Webb",
      email: "curtis.weaver@example.com",
      activity: "Browsing",
      time: "53 min",
      chatWith: "-",
      action : "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 5,
      name: "Savannah Nguyen",
      email: "kenzi.lawson@example.com",
      activity: "Queued",
      time: "12 min",
      chatWith: "Leslie Alexander",
      action : "Pick from Queue",
      actionType: "green",
      avatar: null,
      trafficStatus: "queued",
    },
    {
      id: 6,
      name: "Wade Warren",
      email: "sara.cruz@example.com",
      activity: "Browsing",
      time: "20 min",
      chatWith: "-",
      action: "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 7,
      name: "Esther Howard",
      email: "alma.lawson@example.com",
      activity: "Browsing",
      time: "45 min",
      chatWith: "-",
      action: "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 8,
      name: "Albert Flores",
      email: "michael.mitc@example.com",
      activity: "Invited",
      time: "50 min",
      chatWith: "-",
      action: "View Chat",
      actionType: "blue",
      avatar: null,
      trafficStatus: "invited",
    },
    {
      id: 9,
      name: "Bessie Cooper",
      email: "bessie.cooper@example.com",
      activity: "Chatting",
      time: "5 min",
      chatWith: "Arlene McCoy",
      action : "View Chat",
      actionType: "blue",
      avatar: null,
      trafficStatus: "chatting",
    },
    {
      id: 10,
      name: "Wade Warren",
      email: "sara.cruz@example.com",
      activity: "Browsing",
      time: "20 min",
      chatWith: "-",
      action: "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 11,
      name: "Esther Howard",
      email: "alma.lawson@example.com",
      activity: "Browsing",
      time: "45 min",
      chatWith: "-",
      action: "Invite to Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "browsing",
    },
    {
      id: 12,
      name: "Albert Flores",
      email: "michael.mitc@example.com",
      activity: "Invited",
      time: "50 min",
      chatWith: "-",
      action: "View Chat",
      actionType: "white",
      avatar: null,
      trafficStatus: "invited",
    },
    {
      id: 13,
      name: "Bessie Cooper",
      email: "bessie.cooper@example.com",
      activity: "Chatting",
      time: "5 min",
      chatWith: "Arlene McCoy",
      action : "View Chat",
      actionType: "blue",
      avatar: null,
      trafficStatus: "chatting",
    },
  ]

export { DATA_EXPORT_REPORTS_MOCK } from "./dataExportReports";